import useGames from '@/hooks/useGames';
import useGameStore from '@/store';
import { useT } from '@/i18n/useLanguage';
import { SimpleGrid, Spinner, Flex, Text, Box } from '@chakra-ui/react';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import GameCards from './GameCards';

const GameGrid = () => {
	const selectedQuery = useGameStore((s) => s.gameQuery);
	const { data, error, isLoading, fetchNextPage, hasNextPage } = useGames(selectedQuery);
	const t = useT();

	const skeletons = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

	if (error)
		return (
			<Box py={20} textAlign="center">
				<Text color="fg.muted">{t('couldNotLoad')}</Text>
			</Box>
		);

	const gamesCount =
		data?.pages.reduce((total, page) => total + page.results.length, 0) || 0;

	return (
		<InfiniteScroll
			dataLength={gamesCount}
			hasMore={!!hasNextPage}
			next={fetchNextPage}
			loader={
				<Flex justify="center" py={8}>
					<Spinner color="brand.400" />
				</Flex>
			}
		>
			<SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 3, xl: 4 }} gap={5}>
				{isLoading
					? skeletons.map((s) => <GameCards key={s} />)
					: data?.pages.map((page, index) => (
							<React.Fragment key={index}>
								{page.results?.map((game) => (
									<GameCards key={game.id} game={game} />
								))}
							</React.Fragment>
					  ))}
			</SimpleGrid>
		</InfiniteScroll>
	);
};

export default GameGrid;
